import { render } from "./training.vue?vue&type=template&id=d121b6f8&scoped=true"
import script from "./training.js?vue&type=script&lang=js"
export * from "./training.js?vue&type=script&lang=js"

import "./training.vue?vue&type=style&index=0&id=d121b6f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d121b6f8"]])

export default __exports__